import { render, staticRenderFns } from "./AccessionHistoryLabSetting.vue?vue&type=template&id=bb3ebbd4&scoped=true&"
import script from "./AccessionHistoryLabSetting.vue?vue&type=script&lang=js&"
export * from "./AccessionHistoryLabSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3ebbd4",
  null
  
)

export default component.exports